import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../pages/admin/Admin.css';

const API_BASE = 'https://doticom.vn:5000/api/DieuChuyenKho/store/';

function formatDate(date) {
  return date.toISOString().slice(0, 10);
}

const ListDieuChuyen = () => {
  const [data, setData] = useState([]);
  const [date, setDate] = useState(formatDate(new Date()));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [tab, setTab] = useState('nhanve'); // 'nhanve' or 'chuyendi'

  const maCH = localStorage.getItem('MaCH') || '47';

  const fetchData = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.get(
        `${API_BASE}${maCH}?TuNgay=${date}&DenNgay=${date}`
      );
      setData(res.data.data || []);
    } catch (e) {
      setError('Lỗi tải dữ liệu');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [date]);

  const today = formatDate(new Date());

  const filteredData = data.filter(item =>
    tab === 'nhanve' ? item.direction === 2 : item.direction === 1
  );

  return (
    <div className="dieu-chuyen-container" style={{ width: '100%' }}>
      <div className="card mb-3" style={{ width: '100%', marginBottom: 0 }}>
        <div className="section-header">
          <h2>Danh sách điều chuyển kho</h2>
          <p>Xem danh sách phiếu nhận về hoặc chuyển đi</p>
        </div>
        <div className="card-header">
          <label htmlFor="date">Chọn ngày:</label>
          <input
            id="date"
            type="date"
            className="form-control form-control-sm me-2"
            value={date}
            onChange={e => setDate(e.target.value)}
            style={{ maxWidth: 180, display: 'inline-block' }}
          />
          <button className="btn btn-outline-primary btn-sm me-2" onClick={fetchData}>Tải lại</button>
          <button
            className={`btn btn-sm ${tab === 'nhanve' ? 'btn-primary' : 'btn-outline-primary'} me-2`}
            onClick={() => setTab('nhanve')}
          >
            Nhận về
          </button>
          <button
            className={`btn btn-sm ${tab === 'chuyendi' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setTab('chuyendi')}
          >
            Chuyển đi
          </button>
        </div>
        <div className="card-body" style={{ padding: '20px 0' }}>
          {loading && <div className="spinner-border text-primary" />}
          {error && <div className="text-danger mb-2">{error}</div>}
          <div className="table-responsive" style={{ width: '100%' }}>
            <table className="table table-striped table-bordered" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Mã SP</th>
                  <th>Tên SP</th>
                  <th>ĐVT</th>
                  <th>Đơn giá</th>
                  <th>Người tạo</th>
                  <th>Ngày điều chuyển</th>
                  <th>Loại</th>
                  <th>Số lượng</th>
                  {tab === 'nhanve' ? (
                    <th>IDCH chuyển</th>
                  ) : (
                    <th>IDCH nhận</th>
                  )}
                  <th>Đã xác nhận</th>
                  <th>Số lượng xác nhận</th>
                  <th>Người xác nhận</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map(item => {
                  const isToday =
                    item.ngayDieuChuyen &&
                    item.ngayDieuChuyen.slice(0, 10) === today;
                  return (
                    <tr
                      key={item.id}
                      style={{
                        background: isToday ? '#ffeeba' : '',
                        opacity: item.daxacnhan ? 0.6 : 1,
                      }}
                    >
                      <td>{item.maSP}</td>
                      <td>{item.ten_SP}</td>
                      <td>{item.dvT_SP}</td>
                      <td>{item.donGia}</td>
                      <td>{item.tenUser}</td>
                      <td>{item.ngayDieuChuyen.slice(0, 10)}</td>
                      <td>{item.directionText}</td>
                      <td>{item.soLuongDieuChuyen}</td>
                      {tab === 'nhanve' ? (
                        <td>{item.idcH_Chuyen}</td>
                      ) : (
                        <td>{item.idcH_Nhan}</td>
                      )}
                      <td>
                        {item.daxacnhan ? (
                          <span className="badge bg-primary">Đã xác nhận</span>
                        ) : (
                          <span className="badge bg-secondary">Chưa xác nhận</span>
                        )}
                      </td>
                      <td>{item.soLuongXacNhan || ''}</td>
                      <td>{item.nguoiXacNhan || ''}</td>
                    </tr>
                  );
                })}
                {filteredData.length === 0 && (
                  <tr>
                    <td colSpan={13} className="text-center text-muted">
                      Không có dữ liệu
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListDieuChuyen;
